import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { DiscountDto } from '@coretava/api/ecommerce-service';
import CongratsActions from './CongratsActions';
import { useDiscountDescription } from './hooks';

const Congrats: React.FC<{
  discount: DiscountDto,
}> = ({
  discount,
}) => {
  const description = useDiscountDescription(discount);

  return (
    <Stack gap={1} mt={2}>
      <Typography fontSize={14} fontWeight={600}>
        <Trans i18nKey="campaigns.boosters.referral.widget.congrats" defaults="Congratulations! 🎉" />
      </Typography>
      <Typography fontSize={14} fontWeight={400}>
        {description}
      </Typography>
      <CongratsActions discount={discount} />
    </Stack>
  );
};

export default Congrats;
